import { useSelector } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey, ActionType } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { ModalWrapper, ModalBodyWrapper } from '@mews-commander/ui';
import { WithGuideLink, WithScope } from '@mews-commander/types';
import { isCurrentEnterpriseServiceProviderWithBookableService } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';
import { useCloseButton } from '../../core/windowManager/hooks';
import { HeadingAction } from '../../legacy/React/Components/HeadingAction/Action/types';
import { NewReservation } from './initialize';
import { NewReservationScreenUrlParams } from './schemas/urlParamsSchema';

interface NewReservationContainerProps extends WithScope, WithGuideLink {
    searchParams: NewReservationScreenUrlParams;
}

export const NewReservationContainer: React.FC<NewReservationContainerProps> = ({ scope, guideLink, searchParams }) => {
    // @ts-expect-error $TSFixMeError: Type 'unknown' is not assignable to type 'boolean'.
    const hasBookableService: boolean = useSelector(isCurrentEnterpriseServiceProviderWithBookableService);
    const closeButton = useCloseButton();

    if (!hasBookableService) {
        return null;
    }

    const actions: HeadingAction[] = [
        {
            url: guideLink,
            type: ActionType.Link,
            actionId: 'help',
            text: <LocalizedText textKey={TextKey.Help} />,
            icon: IconName.Help,
            target: '_blank',
        },
    ];

    return (
        <ModalWrapper>
            <ModalHeader
                title={<LocalizedText textKey={TextKey.NewReservation} />}
                actions={actions}
                primaryAction={closeButton}
            />
            <ModalBodyWrapper padded>
                <NewReservation scope={scope} searchParams={searchParams} />
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
